import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { LANGUAGE_STORAGE_KEY } from "~/shared/config/i18n.constants";
import { readString, writeString } from "~/shared/lib/storage";

export const useLanguagePersistence = () => {
    const { i18n } = useTranslation();

    useEffect(() => {
        const savedLanguage = readString(LANGUAGE_STORAGE_KEY);

        if (savedLanguage && ["en", "ru"].includes(savedLanguage)) {
            if (savedLanguage !== i18n.language) {
                void i18n.changeLanguage(savedLanguage);
            }
        } else {
            writeString(LANGUAGE_STORAGE_KEY, i18n.language);
        }
    }, [i18n]);
};
